import {
  BankOutlined,
  GlobalOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";

const forms = [
  {
    name: <div className="text-[#2d53da] text-semi-bold text-2xl">Sign Up</div>,
    className: "flex items-center min-h-screen w-full",
    body: {
      className: "bg-white p-4 border rounded-lg p-8 w-[20%] mx-auto",
    },
    formdata: {
      className: "text-sm text-medium text-gray-500 rounded-md",
    },
    options: [
      {
        name: "",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Name",
          className: "",
          size: "large",
          suffix: <UserOutlined className="text-gray-500" />,
          value: "",
          required: true,
        },
      },
      {
        name: "",
        type: "input",
        form: {
          type: "text",
          name: "company",
          placeholder: "Company",
          className: "",
          size: "large",
          suffix: <BankOutlined className="text-gray-500" />,
          value: "",
          required: true,
        },
      },
      {
        name: "",
        type: "input",
        form: {
          type: "tel",
          name: "phone",
          placeholder: "Phone",
          className: "",
          size: "large",
          suffix: <PhoneOutlined className="text-gray-500" />,
          value: "",
          required: true,
        },
      },
      {
        name: "",
        type: "input",
        form: {
          type: "email",
          name: "email",
          placeholder: "Email",
          className: "",
          size: "large",
          suffix: <MailOutlined className="text-gray-500" />,
          value: "",
          required: true,
        },
      },
      {
        name: "",
        type: "password",
        form: {
          type: "text",
          name: "password",
          placeholder: "Password",
          className: "",
          size: "large",
          value: "",
          required: true,
        },
      },
      {
        name: "",
        type: "input",
        form: {
          type: "text",
          name: "country",
          placeholder: "Country",
          className: "",
          size: "large",
          suffix: <GlobalOutlined className="text-gray-500" />,
          value: "",
          required: true,
        },
      },
    ],
    button: "",
  },
];

export default forms;
